import { Access, AccessOverview } from 'projects/access-gui/views/access'

module.exports = [
  {
    path: '/access',
    exact: true,
    component: AccessOverview
  }, {
    path: '/access/:accessid',
    exact: true,
    component: Access
  }
]



// WEBPACK FOOTER //
// ./src/projects/access-gui/routes/access.js